const summary = document.querySelector("summary");
const defaultText = "もっと見る";
const openText = "閉じる";

document.querySelector("details").addEventListener("toggle", e => {
	summary.classList.add("fadeout");

	setTimeout(() => {
		if (e.target.open) {
			summary.textContent = openText;
			summary.classList.add("is-close");
		} else {
			summary.textContent = defaultText;
			summary.classList.remove("is-close");
		}

		summary.classList.remove("fadeout");
		summary.classList.add("fadein");

		setTimeout(() => summary.classList.remove("fadein"), 300);
	}, 300);
});
